export default {
  globalParams: {},
  acquisitionInfo: {},
  participateInfo: {},
  payInfo: {},
  selectedCard: {},
  membership: {},
  extraInfoList: [],
  brandName: 'DiDi Pack',
  unSubscribeInfoData: {},
  paySuccessInfo: {}, // 支付成功信息
  foodNotOpen: 1, //  1-未在外卖开国 0-已在外卖开国
  transNationalInfo: {}, // 会员跨国订阅信息
  urlNoSubscribe: 0, // 会员页入参
  newCouponPackDetail: {}, // 新券包详情信息
}
